<template>
  <r-panel :title="title" :button_add="true" @click_add="row_create">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer
        dense
        :show-select="bulkMode"
        v-model="selected"
        item-key="kind.key"
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <div v-if="showBulk && (items.length >= 2)" class="d-flex pl-4 pb-1 align-center">
          <v-checkbox
            v-model="bulkMode"
            hide-details
            :disabled="!items.length"
            class="mt-0 pt-0"
          />

          <v-btn
            x-small
            class="ma-2 white--text"
            color="red"
            :disabled="!bulkMode || !deletableCountLocal"
            @click="bulkRemove"
          >
            Bulk Delete
            <span v-if="deletableCountLocal"> ({{ deletableCountLocal }})</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.notEnough="{item}">
        {{ item.notEnough ? "ON" : "OFF" }}
      </template>
      <template v-slot:item.lower="{item}">
        <div>{{ item.lower > 0 ? item.lower : "-" }}</div>
      </template>
      <template v-slot:item.upper="{item}">
        <div>{{ item.upper > 0 ? item.upper : "-" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>

    <r-guard-money-rule-dialog ref="dialog"/>
  </r-panel>
</template>

<script>

import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {GuardMoney} from "@/modules/redactor/models/guard/GuardMoney";

import RPanel from "@/modules/redactor/views/utils/r-panel";
import RGuardMoneyRuleDialog from "@/modules/redactor/views/guard/r-guard-money-rule-dialog";


export default {
  name: "r-guard-money-panel",
  components: {RGuardMoneyRuleDialog, RPanel},
  props: {
    title: VueTypes.string.def("Guard Money"),
    model: VueTypes.instanceOf(GuardMoney),
    showBulk: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      {text: 'Currency', value: 'kind.key'},
      {text: 'Not Enough', value: 'notEnough'},
      {text: 'Lower', value: 'lower'},
      {text: 'Upper', value: 'upper'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    selected: [],
    bulkMode: false,
  }),
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new GuardMoney();
        this.$emit("update:model", value);
        return value;
      }
    },
    items() {
      return this.value.rules;
    },
    empty() {
      return this.items.length === 0;
    },

    deletableCountLocal() {
      return this.selected.length;
    },
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },

    bulkRemove() {
      if (!this.selected.length) return;

      this.$confirm("Are you sure you want to delete selected items?")
        .then(() => {
          this.selected.forEach(item => {
            const index = this.items.indexOf(item);
            if (index !== -1) {
              this.items.splice(index, 1);
            }
          });
          this.selected = [];
          this.bulkMode = false;
        })
        .catch(() => {});
    }
  },

  watch: {
    items(newItems) {
      this.selected = this.selected.filter(v => newItems.includes(v));
    },

    bulkMode(value) {
      if (!value) {
        this.selected = [];
      }
    }
  }
}

</script>